import { quemSomosEPilaresContent as c } from "./content";

export function Goals() {
  return (
    <>

      <section className="home-page-v2__section home-page-v2__section--pilares">
        <section className="home-page-v2__section home-page-v2__section--sobre">
          <div
            className="home-page-v2__section-inner home-page-v2__sobre--quemsomos"
          >
            <h2>{c.quemSomos.heading}</h2>
            <p>{c.quemSomos.body}</p>
          </div>

          <br />

          <div className="home-page-v2__section-inner">
            <div className="box">
              <h2
                id="nossos-pilares-heading"
                className="home-page-v2__heading-outline"
                style={{ textAlign: "center" }}
              >
                {c.nossosPilares.sectionTitle}
              </h2>
              <ul className="home-page-v2__pilares-grid">
                {c.nossosPilares.pillars.map((p) => (
                  <li key={p.title}>
                    <strong>{p.title}</strong>
                    <span className="home-page-v2__pilares-desc">{p.description}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>


      </section>
    </>
  );
}
